import axios from 'axios'
import Vue from 'vue'
import router from '@/router'
import Cookies from 'js-cookie'
// import store from '@/store'
// import {
// 	getToken
// } from '@/utils/auth'
import {
	Message,
	Modal
} from 'iview'
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'
// 创建axios实例

// 接口地址
// var host = "http://172.20.0.15:8089";//何
// var host = "http://172.20.0.108:8089";//测试
var host = "http://36.138.114.21:8086";//生产

// 上传图片地址
var imgHost = "http://36.138.114.21:8086/jeecg-boot/webfile/upfile";//生产
// var imgHost = "http://172.20.0.222:8089/jeecg-boot/webfile/upfile";//测试

// 查看图片地址
var previewImg = "http://36.138.114.21:8086/file_resources/"//生产
// var previewImg = "http://172.20.0.222:8082/file_resources/"//测试
axios.defaults.baseURL = host;
Vue.prototype.$host = host;
Vue.prototype.$imgHost = imgHost;
Vue.prototype.$previewImg = previewImg;
const service = axios.create({
	// 超时
	timeout: 60000
})
// request拦截器
service.interceptors.request.use(config => {
	// 是否需要设置 token
	// const isToken = (config.headers || {}).isToken === false
	// const token = JSON.parse(Cookies.get('userInfo')).token;
	// if (token && !isToken) {
	// 	config.headers['X-Access-Token'] = token
	// }
	return config
}, error => {
	console.log(error)
	Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
		// 未设置状态码则默认成功状态
		const code = res.data.code || 200;
		// 获取错误信息
		const message = res.data.message
		if (code == 200 || code == 311) {
			return res.data
		}
		if (code === 401 || code === 444) {
			// Modal.error({
			// 	title: '提示',
			// 	content: '登录失效，请登录后查询！',
			// 	onOk: () => {
			// 		Cookies.remove('userInfo');
			// 		router.replace('memberLogin');
			// 	},
			// });
			return res.data
		} else if (code === 500 || code === 411) {
			Modal.error({
				title: '错误',
				content: message
			});
			return res.data
		} else {
			Message.error(message)
			return res.data
		}
	},
	error => {
		Message.error('服务异常！请联系管理员', 5 * 1000)
		return Promise.reject(error)
	}
)

export default service
